/* eslint-disable react/prop-types */
import React, { useState } from "react"; // React Stuff
import axios from "axios";
import { Col, Row, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const BlockDelete = (props) => {
  // Deletion state
  const [deleting, setDeleting] = useState(false);
  const blockid = props.data._id;
  const venueid = props.data.Venue._id;
  const navigate = useNavigate();
  const deleteClass = async (e) => {
    e.preventDefault();
    const deleteRequest = await axios.delete(`/api/admin/manage/blocks/${venueid}/${blockid}`, {
      withCredentials: true,
    });
    if (deleteRequest.status === 200) {
      props.setSubmitClicked(false);
      return navigate("/admin/overview/", { replace: true });
    } else {
      props.setSubmitClicked(false);
      return props.setErrorMessage("There was a problem with your request.");
    }
  };
  return (
    <Row className='mt-4 mb-4 text-center'>
      <Col sm='12' className='border shadow p-3'>
        <p>
          The class must have passed its final date or be empty of participants before it can be
          deleted. Deleted blocks are unrecoverable. You will be redirected to the class overview.
        </p>
        {!deleting ? (
          <Button
            variant='warning'
            className='mt-3 mb-4'
            type='button'
            onClick={() => setDeleting(true)}
          >
            Delete Block
          </Button>
        ) : (
          <>
          <Button
            variant='danger'
            className='mt-3 mb-4'
            type='button'
            onClick={(e) => deleteClass(e)}
          >
            Confirm
          </Button>
          <Button  variant='secondary'
          className='ms-1 mt-3 mb-4'
          type='button'
          onClick={() => setDeleting(false)}
          >
            Cancel
          </Button>
          </>
        )}
      </Col>
    </Row>
  );
};

export default BlockDelete;
